/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Intake_CtaInputs */



/**
* | output |
* | --- |
* | "Answer in the chat" |
*
* @param {Meeting_Prep_Intake_CtaInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_intake_cta = /** @type {((inputs?: Meeting_Prep_Intake_CtaInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Intake_CtaInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Antwoord in de chat")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Répondre dans le chat")
	return /** @type {LocalizedString} */ ("Answer in the chat")
});